"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var React = require("react");
var stat_1 = require("~@/widget/stat/stat");
var user_1 = require("~/js/lib/user/user");
var then_ajax_1 = require("then-ajax");
require("./right-userinfo.scss");
var util_1 = require("src/js/lib/util/util");
var FETCH_INTERVAL = 300;
var INTERFACE = {
    REGISTER_REPORT: '//w.yy.com/task/center/registered?appType=2',
    GOLD: '//w.yy.com/gold/gold/account/get',
    UNREAD_MESSAGE: '//www.yy.com/zone/message/getMsgTabCount.json?userType=0&msgTypeList=101'
};
var RightUserinfo = (function (_super) {
    __extends(RightUserinfo, _super);
    function RightUserinfo(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isHover: false,
            unreadMsg: false,
            showTask: false,
            isLivePage: window.pageInfo && window.pageInfo.position === 'studio',
            userExtInfo: {
                isExpired: false,
                nobleLevel: 0,
                honourLevel: 0,
                curHonour: 0,
                goalHonour: 0,
                honourRatio: 0,
                hadCherish: false,
                diamond: '-',
                yyMoney: '-',
                yyMoneyOriginal: 0,
                cherishGroupName: '0',
                isAnchor: false,
                role: '',
                nobleLevelName: '',
                gold: '-'
            }
        };
        _this.fetchData = util_1.debounce(function () {
            _this.fetchUserExtInfo()["catch"](function () { return undefined; });
            _this.fetchGold()["catch"](function () { return undefined; });
            _this.fetchUnreadMsg()["catch"](function () { return undefined; });
        }, FETCH_INTERVAL);
        return _this;
    }
    RightUserinfo.prototype.render = function () {
        var _a = this.state, isHover = _a.isHover, unreadMsg = _a.unreadMsg, userExtInfo = _a.userExtInfo, isLivePage = _a.isLivePage;
        var _b = this.props, reg = _b.reg, login = _b.login, logout = _b.logout, isLogined = _b.isLogined, userInfo = _b.userInfo;
        var nobleIconTitle = isLivePage ? '点亮身份象征，尽享尊贵特权！主人，你有点腻害呀' : '进入娱乐直播间再点我咯~';
        var cherishIconTitle = isLivePage ? '喜欢就要会表达，为TA开个珍爱吧！' : '进入娱乐直播间再点我咯~';
        if (isLivePage) {
            if (userExtInfo.isExpired) {
                nobleIconTitle = '已过期';
            }
            else {
                nobleIconTitle = "LV" + userExtInfo.honourLevel;
            }
            if (userExtInfo.hadCherish) {
                cherishIconTitle = "\u56E2\u52CB\u7AE0\uFF1A" + userExtInfo.cherishGroupName;
            }
        }
        var showReddot = unreadMsg;
        var usercenterUrl = 'https://www.yy.com/i/';
        if (userInfo.isGuild) {
            usercenterUrl = 'https://www.yy.com/gid/';
        }
        else {
            if (userExtInfo.role === '1') {
                usercenterUrl = '//ww.yy.com/i/income';
            }
            else if (userExtInfo.role === '2') {
                usercenterUrl = '//ww.yy.com/i/anchorManage/signAnchors';
            }
        }
        var ModWallet = (React.createElement("div", { className: "p-header__wallet" },
            React.createElement("a", { className: "p-header__wallet__tl", href: "//www.yy.com/i/asset/y_coin", target: "_blank" },
                React.createElement("span", { className: "p-header__wallet__tl__t" }, "\u6211\u7684\u94B1\u5305")),
            React.createElement("a", { className: "p-header__wallet__btn", href: "//pay.duowan.com/userDepositDWAction.action", target: "_blank" }, "\u5145\u503C"),
            React.createElement("div", { className: "p-header__wallet__cnt" },
                React.createElement("a", { className: "p-header__wallet__cnt__item", title: "y\u5E01", href: "javascript:;" },
                    React.createElement("span", { className: "p-header__wallet__icon p-header__wallet__icon--yb" }),
                    React.createElement("span", { className: "p-header__wallet__cnt__item__t" }, userExtInfo.yyMoney)),
                React.createElement("a", { className: "p-header__wallet__cnt__item", title: "\u7EA2\u94BB", href: "javascript:;" },
                    React.createElement("span", { className: "p-header__wallet__icon p-header__wallet__icon--red" }),
                    React.createElement("span", { className: "p-header__wallet__cnt__item__t" }, userExtInfo.diamond)))));
        var ModNav = (React.createElement("div", { className: "p-header__userinfo-nav" },
            React.createElement("a", { className: "p-header__userinfo-nav__item", href: usercenterUrl, target: "_blank" }, "\u4E2A\u4EBA\u4E2D\u5FC3"),
            React.createElement("a", { className: "p-header__userinfo-nav__item " + (unreadMsg ? 'p-header__userinfo-nav__item--new' : ''), href: "//www.yy.com/i/messages", target: "_blank" }, "\u6211\u7684\u6D88\u606F"),
            React.createElement("a", { className: "p-header__userinfo-nav__item", href: "//www.yy.com/i/privilege/noble", target: "_blank" }, "\u6211\u7684\u7279\u6743")));
        return (React.createElement("div", { className: "p-header__main__cnt__right__item p-header__main__cnt__right__item--userinfo", onMouseEnter: this.onDragEnter.bind(this), onMouseLeave: this.onDragLeave.bind(this) },
            isLogined && (React.createElement(React.Fragment, null,
                React.createElement("a", { className: "p-header__userinfo__cover", href: usercenterUrl, onClick: function () { return stat_1.stat(stat_1.EStatType.USERINFO_AVATAR_CLICK); } },
                    React.createElement("div", { className: "p-header__userinfo__cover__reddot " + (showReddot ? 'active' : '') }),
                    React.createElement("img", { className: "p-header__userinfo__cover__img", src: userInfo.logo, alt: userInfo.nick })),
                React.createElement("div", { className: "p-header__drag " + (isHover ? 'p-header__drag--show' : '') },
                    React.createElement("span", { className: "p-header__drag__enterstage" },
                        React.createElement("i", { className: "p-header__drag__enterstage__tri" }),
                        React.createElement("i", { className: "p-header__drag__enterstage__tri2" })),
                    React.createElement("div", { className: "p-header__drag__main" },
                        React.createElement("a", { className: "p-header__userinfo__main__logout", href: "javascript:;", onClick: this.logoutClick.bind(this) }, "\u9000\u51FA\u767B\u5F55"),
                        React.createElement("div", { className: "p-header__userinfo__main__intro" },
                            React.createElement("a", { className: "p-header__userinfo__main__nick", href: usercenterUrl }, userInfo.nick),
                            React.createElement("div", { className: "p-header__userinfo__main__medal-icons" },
                                React.createElement("a", { className: "p-header__icon-noble p-header__icon-noble--" + userExtInfo.nobleLevel, href: "javascript:;", title: nobleIconTitle, onClick: this.nobleClick.bind(this) }),
                                React.createElement("a", { className: "p-header__icon-cherish " + (userExtInfo.hadCherish ? 'p-header__icon-cherish--enable' : ''), title: cherishIconTitle, href: "javascript:;", onClick: this.cherishClick.bind(this) }))),
                        ModWallet,
                        ModNav)))),
            !isLogined && (React.createElement("div", { className: "p-header__main__cnt__right__item__tl" },
                React.createElement("i", { className: "p-header__main__cnt__right__item__tl__icon" }),
                React.createElement("a", { className: "p-header__main__cnt__right__item__tl__t", href: "javascript:;", onClick: this.loginClick.bind(this) },
                    React.createElement("span", null, "\u767B\u5F55")),
                React.createElement("i", { className: "p-header__main__cnt__right__item__tl__line" }),
                React.createElement("a", { className: "p-header__main__cnt__right__item__tl__t wHead__register__btn", href: "javascript:;", onClick: this.regClick.bind(this) },
                    React.createElement("span", null, "\u6CE8\u518C"))))));
    };
    RightUserinfo.prototype.componentWillUpdate = function (nextProps) {
        var isLogined = this.props.isLogined;
        if (isLogined !== nextProps.isLogined) {
            this.resetData();
        }
    };
    RightUserinfo.prototype.fetchUserExtInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userExtInfo, timeStart, _a, err, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        userExtInfo = this.state.userExtInfo;
                        timeStart = +new Date();
                        return [4, user_1.fetchUserInfoByRevenue()];
                    case 1:
                        _a = _b.sent(), err = _a[0], data = _a[1];
                        this.setState({
                            userExtInfo: Object.assign(userExtInfo, data)
                        });
                        stat_1.metrics(stat_1.EMetricsType.USERCAR_FETCH_USER_INFO_BY_REVENUE, {
                            cost: +new Date() - timeStart,
                            code: err ? err.code : 0
                        });
                        return [2];
                }
            });
        });
    };
    RightUserinfo.prototype.fetchGold = function () {
        return __awaiter(this, void 0, void 0, function () {
            var timeStart, userExtInfo, rs, r;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        timeStart = +new Date();
                        userExtInfo = this.state.userExtInfo;
                        return [4, then_ajax_1.thenJsonp(INTERFACE.GOLD)];
                    case 1:
                        rs = _a.sent();
                        r = '-';
                        if (rs.code === 0 || rs.code === 2) {
                            if (rs.data && rs.data.totalAmount) {
                                r = util_1.moneyFormat(rs.data.totalAmount || 0);
                            }
                        }
                        this.setState({
                            userExtInfo: Object.assign(userExtInfo, {
                                gold: r
                            })
                        });
                        stat_1.metrics(stat_1.EMetricsType.USERCAR_GOLD, {
                            cost: +new Date() - timeStart,
                            code: rs.code
                        });
                        return [2];
                }
            });
        });
    };
    RightUserinfo.prototype.fetchUnreadMsg = function () {
        return __awaiter(this, void 0, void 0, function () {
            var rs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, then_ajax_1.thenGet(INTERFACE.UNREAD_MESSAGE)];
                    case 1:
                        rs = _a.sent();
                        this.setState({
                            unreadMsg: rs.data && rs.data.unread ? true : false
                        });
                        return [2];
                }
            });
        });
    };
    RightUserinfo.prototype.resetData = function () {
        this.setState({
            unreadMsg: false,
            userExtInfo: {
                isExpired: false,
                nobleLevel: 0,
                honourLevel: 0,
                curHonour: 0,
                goalHonour: 0,
                honourRatio: 0,
                hadCherish: false,
                diamond: '-',
                yyMoney: '-',
                yyMoneyOriginal: 0,
                cherishGroupName: '',
                isAnchor: false,
                role: '',
                nobleLevelName: '',
                gold: '-'
            }
        });
    };
    RightUserinfo.prototype.onDragEnter = function () {
        this.setState({
            isHover: true
        });
        if (this.props.isLogined) {
            this.fetchData();
        }
    };
    RightUserinfo.prototype.onDragLeave = function () {
        this.setState({
            isHover: false
        });
    };
    RightUserinfo.prototype.logoutClick = function () {
        this.props.logout();
    };
    RightUserinfo.prototype.nobleClick = function () {
        if (window.roomNoble) {
            window.roomNoble.noblePop.show(3);
        }
    };
    RightUserinfo.prototype.cherishClick = function () {
        if (window.cherish) {
            window.cherish.openCherishDialog(3);
        }
    };
    RightUserinfo.prototype.loginClick = function () {
        this.props.login();
    };
    RightUserinfo.prototype.regClick = function () {
        var _this = this;
        this.props.reg(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, then_ajax_1.thenJsonp(INTERFACE.REGISTER_REPORT)];
                    case 1:
                        _a.sent();
                        stat_1.stat(stat_1.EStatType.UDB_REG_REPORT);
                        return [2];
                }
            });
        }); });
    };
    return RightUserinfo;
}(React.Component));
exports.RightUserinfo = RightUserinfo;
